module.exports = __webpack_public_path__ + "static/media/achievement-post-exercise-demo.7dcc28df.svg";